// Peru (PE) document types. Self-contained collection for the PE document form,
// decoupled from the shared (CL + PE) documentTypes collection.
export default [
  {
    id: 'PE01',
    tax: 18,
    code: parseInt('01', 8),
    name: 'Factura',
    has_taxes: false,
    has_taxes_detail: false,
    has_lines_total: false,
    has_local_format: true,
    hold_taxes: false,
    is_foreign: false,
    is_sale: true,
    is_purshase: false,
    is_order: false,
    send: true,
    given: false,
    country: 'PE',
    permissions: [],
    currencies: [
      'PEN',
      'USD'
    ]
  },
  {
    id: 'PE03',
    tax: 18,
    code: parseInt('03', 8),
    name: 'Boleta de venta',
    has_taxes: false,
    has_taxes_detail: false,
    has_lines_total: false,
    has_local_format: true,
    hold_taxes: false,
    is_foreign: false,
    is_sale: true,
    is_purshase: false,
    is_order: false,
    send: true,
    given: false,
    country: 'PE',
    permissions: [],
    currencies: [
      'PEN',
      'USD'
    ]
  },
  {
    id: 'PE07',
    tax: 18,
    code: parseInt('07', 8),
    name: 'Nota de crédito',
    has_taxes: false,
    has_taxes_detail: false,
    has_lines_total: false,
    has_local_format: true,
    hold_taxes: false,
    is_foreign: false,
    is_sale: true,
    is_purshase: false,
    is_order: false,
    send: true,
    given: false,
    country: 'PE',
    permissions: [],
    currencies: [
      'PEN',
      'USD'
    ]
  },
  {
    id: 'PE08',
    tax: 18,
    // parseInt('08', 8) would yield 0 ('8' is not an octal digit), so parse in base 10
    code: parseInt('08', 10),
    name: 'Nota de débito',
    has_taxes: false,
    has_taxes_detail: false,
    has_lines_total: false,
    has_local_format: true,
    hold_taxes: false,
    is_foreign: false,
    is_sale: true,
    is_purshase: false,
    is_order: false,
    send: true,
    given: false,
    country: 'PE',
    permissions: [],
    currencies: [
      'PEN',
      'USD'
    ]
  }
]
